import "./ContactUs.css";
import { useState } from "react";
import { Link } from 'react-router-dom';
import UploadFileIcon from '@mui/icons-material/UploadFile';

export default function WorkWithUs() {

    const [mexData, setMexData] = useState({});
    const [number, setNumber] = useState("");
    const [file, setFile] = useState(null);

    function handleChange(e) {
        setMexData({...mexData, [e.target.id]: e.target.value});
    }

    function handleFileChange(e) {
        setFile(e.target.files[0]);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', mexData.name);
        formData.append('surname', mexData.surname);
        formData.append('email', mexData.email);
        formData.append('number', mexData.number);
        formData.append('message', mexData.message);
        formData.append('jobSelection', mexData.jobSelection);
        formData.append('file', file);

        try {
            const response = await fetch('/backend/send_workemail.php', {
                method: 'POST',
                body: formData,
            });

            const data = await response.text();
            alert(JSON.parse(data).message);
        } catch (error) {
            console.error('Errore durante l\'invio dell\'email:', error);
            alert('Errore durante l\'invio dell\'email.');
        }
    };

    return (
        <div>
            <div id="formTitle" className="workForm">
                Compila il Form per Candidarti
            </div>
            <form onSubmit={handleSubmit}>
                <div id="userData">
                    <div id="formComponent">
                        <input id="name" placeholder="Nome*" type="text" required onChange={(e) => handleChange(e)}/>
                    </div>
                    <div id="formComponent">
                        <input id="surname" placeholder="Cognome*" type="text" required
                               onChange={(e) => handleChange(e)}/>
                    </div>
                    <div id="formComponent">
                        <input id="email" placeholder="Email*" type="email" required onChange={(e) => handleChange(e)}/>
                    </div>
                    <div id="formComponent">
                        <input
                            id="number"
                            placeholder="Cellulare"
                            type="tel"
                            value={number}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) { // Accetta solo numeri
                                    setNumber(value);
                                }
                            }}
                        />
                    </div>
                </div>
                <div id="formComponent" className="message">
                    <textarea id="message" placeholder="Messaggio (facoltativo)" onChange={(e) => handleChange(e)}/>
                </div>

                <select id="jobSelection" required onChange={(e) => handleChange(e)}>
                    <option value="">Seleziona la tua mansione</option>
                    <option value="Riparatore_elettrodomestici">Riparatore elettrodomestici</option>
                    <option value="Magazziniere">Magazziniere</option>
                    <option value="Agente_di_vendita">Agente di vendita</option>
                    <option value="Addetto_vendita">Addetto vendita</option>
                </select>

                <label id="inputFileContainer">
                    <UploadFileIcon/>
                    <span>Carica File (solo pdf)*</span>
                    <input id="inputFile" type="file" required accept=".pdf" onChange={handleFileChange}/>
                </label>

                <div id="privacyDisclamer">
                    *Cliccando sul tasto "Invia" dichiari di aver letto e accettato <Link to="/privacypage"> le nostre condizioni riguardanti la privacy</Link> ai sensi del Dlgs 196 del 30 giugno 2003 e dell'art. 13 GDPR.
                </div>

                <button id="submitButton">INVIA</button>
            </form>
        </div>
    );
}